// import React from 'react';

const logos = [
  { src: '/resources/images/logos/python.png', alt: 'Python' },
  { src: '/resources/images/logos/hadoop.png', alt: 'Hadoop' },
  { src: '/resources/images/logos/spark.png', alt: 'Spark' },
  { src: '/resources/images/logos/numpy.png', alt: 'Numpy' },
  { src: '/resources/images/logos/pandas.png', alt: 'Pandas' },
  { src: '/resources/images/logos/plotly.png', alt: 'Plotly' },
  { src: '/resources/images/logos/sklearn.png', alt: 'SkLearn' },
  { src: '/resources/images/logos/tf.png', alt: 'TensorFlow' },
  { src: '/resources/images/logos/keras.png', alt: 'Keras' },
  { src: '/resources/images/logos/pt.png', alt: 'PyTorch' },
  { src: '/resources/images/logos/hf.png', alt: 'HuggingFace' },
  { src: '/resources/images/logos/langchain.png', alt: 'LangChain' },
  { src: '/resources/images/logos/mlflow.png', alt: 'MlFlow' },
  { src: '/resources/images/logos/flask.png', alt: 'Flask' },
  { src: '/resources/images/logos/fastapi.png', alt: 'FastAPI' },
  { src: '/resources/images/logos/claude.png', alt: 'Claude' },
  { src: '/resources/images/logos/databricks.png', alt: 'Databricks' },
  { src: '/resources/images/logos/aws.png', alt: 'AWS' },
  { src: '/resources/images/logos/git.png', alt: 'Git' },
  { src: '/resources/images/logos/jenkins.png', alt: 'Jenkins' },
  { src: '/resources/images/logos/airflow.png', alt: 'Airflow' },
  { src: '/resources/images/logos/docker.png', alt: 'Docker' },
  { src: '/resources/images/logos/kubernetes.png', alt: 'Kubernetes' },
  { src: '/resources/images/logos/jpnb.png', alt: 'JupyterNotebook' },
  { src: '/resources/images/logos/go.png', alt: 'Go' },
  { src: '/resources/images/logos/react.png', alt: 'React' },
];

function TechLogosScroll() {
  return (
    <section className="tech-stack-section" aria-label="Technology stack">
      <div className="tech-stack-heading">
        <span>Technology stack</span>
        <span>Tools I work with</span>
      </div>
      <div className="tech-stack-window">
        <div className="tech-stack-track animate-marquee">
          <div className="tech-stack-group">
            {logos.map((logo) => (
              <div className="tech-logo" key={logo.alt} title={logo.alt}>
                <img src={logo.src} alt={logo.alt} />
              </div>
            ))}
          </div>
          <div className="tech-stack-group" aria-hidden="true">
            {logos.map((logo) => (
              <div className="tech-logo" key={logo.alt}>
                <img src={logo.src} alt="" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default TechLogosScroll;